import React from 'react';
import ScannerShell from '../Scanner/components/ScannerShell';

const ScannerManual = () => <ScannerShell inputMode="manual" />;

export default ScannerManual;
